import React, { memo } from "react";
import CardTable from "./CardTable";
import Table from "./Table/Table";
import Pagination from "./Table/Pagination";
import NoResultsFound from "./NoResultsFound";
import PopUp from "./PopUp/PopUp";
import Dropdown, { DropdownOption } from "./Dropdown";

type Props = {
  rows: any[];
  columns: any[];
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (p: number) => void;
  onSort: (col: string, dir: "ASC" | "DESC") => void;
  onActionClick?: (rowData: any) => void;
  actionKey?: string;
  sortColumn?: string;
  sortDirection?: "ASC" | "DESC";
  teamsCount?: number;
  hidePaginationCount?: boolean;
  reportOptions?: DropdownOption[];
  teamsCountMessage?: string;
  onReportSelect?: (option: DropdownOption) => void;
  /** When true, suppresses <NoResultsFound /> so it only appears after the API has responded. */
  isLoading?: boolean;
};

const UBTSearchResults: React.FC<Props> = ({
  rows,
  columns,
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onSort,
  onActionClick,
  actionKey = "ubtName",
  sortColumn,
  sortDirection,
  teamsCount,
  teamsCountMessage = "teams Found",
  hidePaginationCount = true,
  reportOptions,
  onReportSelect,
  isLoading = false,
}) => {
  return (
    <>
      {rows.length > 0 ? (
        <>
          {teamsCount !== undefined && (
            <div className="mb-8! flex items-center justify-between">
              <h3 className="m-0!">
                {teamsCount} {teamsCountMessage}
                <PopUp
                  className="ml-1! -medium"
                  headerText="Teams Search Results"
                  message="Click column header to sort."
                ></PopUp>
              </h3>
            </div>
          )}
          {reportOptions && onReportSelect && (
            <div className="mb-4! flex justify-end">
              <Dropdown
                options={reportOptions}
                menuClassName="w-full! min-w-85!"
                buttonClassName="w-full! min-w-50!"
                onSelect={onReportSelect}
                buttonLabel="Select a Report"
              />
            </div>
          )}
          <CardTable>
            <>
              <Table
                columns={columns}
                rows={rows}
                actionKey={actionKey}
                onActionClick={onActionClick}
                onSort={onSort}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
              />
              <div className="mt-4 mobile:relative">
                <Pagination
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  onPageChange={onPageChange}
                  hidePaginationCount={hidePaginationCount}
                />
              </div>
            </>
          </CardTable>
        </>
      ) : (
        !isLoading && <NoResultsFound />
      )}
    </>
  );
};

export default memo(UBTSearchResults);
